module.exports = __webpack_public_path__ + "static/media/img_stp_card_jcb.4dca6613.png";